import { useEffect } from 'react'
import Head from 'next/head'
import { useRouter } from 'next/router'
import CircularProgress from '@mui/material/CircularProgress'
import axios from '../../utils/axiosInstance'
import config from '../../config'

const allowedRedirects = config.allowedRedirects

function TiBetRedirect ({ redirect }) {
  const router = useRouter()
  useEffect(() => {
    if (redirect) {
      router.replace(redirect)
    }
  }, [router, redirect])

  return (
    <div>
      <Head>
        <title>Videresender - ordnett.no</title>
      </Head>
      <div>Videresender <CircularProgress /></div>
    </div>
  )
}

TiBetRedirect.getInitialProps = async ({ res, store, req, query }) => {
  const { params } = query
  const path = '/' + params.join('/')
  const tai = store?.getState().headers.tai
  const locale = 'nb_NO'
  const returnTo = (query.return_to && query.return_to.startsWith(process.env.NEXT_PUBLIC_URL)) ? query.return_to : query.return_to ? process.env.NEXT_PUBLIC_URL + query.return_to : process.env.NEXT_PUBLIC_URL
  if (!tai) {
    if (res) {
      res.writeHead(302, {
        Location: '/login'
      })
      res.end()
    } else {
      return { redirect: '/login' }
    }
  } else if (allowedRedirects.includes(path)) {
    const tiBetLink = await axios.get('/tibetlink', {
      params: {
        path,
        tibet_access_identifier: tai,
        return_to: returnTo,
        locale,
        payment_tracking_data: query.payment_tracking_data
      }
    })
    const rewriteUrl = (tiBetLink.status === 200) ? tiBetLink.data.signedUrl : '/'
    if (typeof window !== 'undefined') {
      document.location.replace(rewriteUrl)
    } else {
      return { redirect: rewriteUrl }
    }
  } else {
    if (res) {
      res.writeHead(302, {
        Location: '/login'
      })
      res.end()
    } else {
      return { redirect: '/login' }
    }
  }
}

export default TiBetRedirect
